import angular from 'angular';

angular
  .module('epdf.admin.activities', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('activities', {
        url: '/admin/activities',
        component: 'activities',
        data: {
          authorizedRole: 'OPERATION'
        }
      });
    }
  ]);
